import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IPostConsentStatemenResponse,
  PostConsentStatementPayload,
} from "models/consentStatement/postConsentStatement";
import { httpStatus } from "configs/httpStatus";
import { postConsentStatement } from "services/consentStatement";
import {
  handleSuccessAction,
  handleErrorAction,
} from "./postConsentStatementActions";

function* postConsentStatementSaga({
  payload,
}: {
  payload: PostConsentStatementPayload;
}) {
  try {
    const response: IPostConsentStatemenResponse = yield call(
      postConsentStatement,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccessAction(response));
    } else if (
      response.status === httpStatus.StatusUnauthorized ||
      response.status === httpStatus.StatusForbidden
    ) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onPostConsentStatementWatcher() {
  yield takeLatest(
    ActionType.POST_CONSENT_STATEMENT as any,
    postConsentStatementSaga
  );
}

export default [fork(onPostConsentStatementWatcher)];
